<div class="card border-round-2xl" [ngClass]="cardsBgColor(site)">
   <div class="grid flex align-items-center">
      <div class="col-3 pt-4 pl-1 pr-0 flex justify-content-center">
         <img id="siteCardMobileImage" class="border-round-lg" [src]="imageSource().src" (click)="selectSite()">
      </div>
      <div class="col-8 pt-2 pb-0 flex align-items-center justify-content-start">
         <div class="flex flex-column w-full">
            <p class="ml-2 my-1 font-semibold text-xl" (click)="selectSite()">
               {{ site.Name | truncate:[25] }}
            </p>
            <p class="ml-2 mb-0" (click)="selectSite()">
               {{ site.Description.length > 0 ? (site.Description | truncate:[30]) : 'NO_DESCRIPTION' | translate }}
            </p>
            <div class="flex flex-row align-items-center justify-content-between">
               <div>
                  <button pButton icon="pi cm-device-connected-small"
                     [pTooltip]="('DEVICES_INSTALLED' | translate) + ': ' + site.Devices.length" tooltipPosition="bottom"
                     tooltipEvent="focus" class="p-button-text text-color"></button>
                  <button pButton icon="pi cm-marker"
                     [pTooltip]="site.Address || ('ADDRESS_NOT_DEFINED' | translate) | truncate:[30]" tooltipPosition="bottom"
                     tooltipEvent="focus" class="p-button-text text-color"></button>
                  <button *ngIf="site.CurrentlyOwned" pButton icon="pi cm-technician"
                     [pTooltip]="(site.CurrentlyOwned && site.TechnicianId) ? ('TECHNICIAN' | translate ) + ': ' + (getTechInfo() | truncate:[30]) : ('NO_TECHNICIAN' | translate)"
                     tooltipPosition="bottom" tooltipEvent="focus" class="p-button-text text-color"></button>
                  <button *ngIf="!site.CurrentlyOwned" pButton icon="pi cm-share"
                     [pTooltip]="(site.Devices[0]) ? ('SHARED_SITE' | translate) + ' ' + ('OWNER' | translate) + ': ' + (site.Devices[0].FirstName + ' ' +  site.Devices[0].LastName | truncate:[30]) : ('SHARED_SITE' | translate)"
                     tooltipPosition="bottom" tooltipEvent="focus" class="p-button-text text-color"></button>
               </div>
               <div class="flex align-items-center gap-3">
                  <div class="flex align-items-center gap-2">
                     <p-badge styleClass="border-circle" severity="success"></p-badge>
                     <span class="pb-1">{{ getDeviceOnline() }}</span>
                  </div>
                  <div class="flex align-items-center gap-2">
                     <p-badge styleClass="border-circle" severity="danger"></p-badge>
                     <span class="pb-1">{{ getDeviceOffline() }}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- <div class="col-3 pt-2 pb-0 flex align-items-center justify-content-end" (click)="selectSite()">
         <div class="flex flex-column">
            <div class="flex flex-row">
               <p-badge styleClass="border-circle" severity="success"></p-badge>
               <div class="ml-2">{{ getDeviceOnline() }}</div>
            </div>
            <div class="flex flex-row">
               <p-badge styleClass="border-circle" severity="danger"></p-badge>
               <div class="ml-2">{{ getDeviceOffline() }}</div>
            </div>
         </div>
      </div> -->
      <!-- MENU BUTTON -->
      <div *ngIf="!fromDialogSelector" class="col-1 flex justify-content-end px-0">
         <button pButton pRipple icon="pi cm-ellipsis-v" class="p-button-text text-color"
            (click)="menu.toggle($event)"></button>
         <p-menu #menu [popup]="true" appendTo="body" [model]="menuitems"></p-menu>
      </div>
   </div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="confDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>